// src/services/cartService.js
import api from './api';

const cartService = {
  /**
   * Get user's cart
   * @returns {Promise<Object>} Cart with items
   */
  getCart: async () => {
    const response = await api.get('/cart');
    return response.data;
  },

  /**
   * Add item to cart (with custom name support)
   * @param {Object} item - { productId, size, quantity, customName }
   * @returns {Promise<Object>} Updated cart
   * 
   * Example:
   * addToCart({
   *   productId: 1,
   *   size: 'M',
   *   quantity: 2,
   *   customName: 'MAYANK'  // Optional
   * })
   */
  addToCart: async (item) => {
    const response = await api.post('/cart/add', item);
    return response.data;
  },

  /**
   * Update cart item quantity
   * @param {number} itemId - Cart item ID
   * @param {number} quantity - New quantity
   * @returns {Promise<Object>} Updated cart
   */
  updateCartItem: async (itemId, quantity) => {
    const response = await api.put(`/cart/update/${itemId}`, null, {
      params: { quantity },
    });
    return response.data;
  },

  /**
   * Remove item from cart
   * @param {number} itemId - Cart item ID
   * @returns {Promise<Object>} Updated cart
   */
  removeCartItem: async (itemId) => {
   
    const response = await api.delete(`/cart/remove/${itemId}`);
    
    return response.data;
  },

  /**
   * Clear entire cart
   * @returns {Promise<Object>} Success message
   */
  clearCart: async () => {
    const response = await api.delete('/cart/clear');
    return response.data;
  },

  /**
   * Get cart item count (for navbar badge)
   * @returns {Promise<number>} Number of items
   */
  getCartItemCount: async () => {
    const response = await api.get('/cart/count');
    return response.data;
  },
};

export default cartService;